import * as React from 'react'
import { Operation } from '../domain/Operation'
import Bottlenecks from '../helper/bottlenecks'
import Shorten from '../helper/shorten'
import TracepointIndicator from '../monitor/operation/tracepoint-indicator'

interface Props {
    operation: Operation
    icon?: any
    full: boolean
}

interface TransactionNameInterface {
    name: string
    tag?: string
}
export function parseTransactionName(identifier: string | undefined): TransactionNameInterface {
    if (!identifier) {
        return {
            name: '',
            tag: undefined,
        }
    }

    const [name, tag, ...unknownRest] = identifier.split('##')

    return { name, tag }
}

export class TransactionName extends React.PureComponent<Props> {
    public render() {
        const transactionIdentifier = this.props.operation.identifier || this.props.operation.name
        const transactionName = parseTransactionName(transactionIdentifier)
        const { active } = this.props.operation

        return (
            <React.Fragment>
                {this.props.icon ? <span className={this.props.icon} /> : null}
                {this.props.operation.bottlenecks ? (
                    <Bottlenecks bottlenecks={this.props.operation.bottlenecks} bottleneckTypes={[]} />
                ) : null}
                {active ? (
                    <Shorten string={transactionName.name} />
                ) : (
                    <span className="tw-font-weight-normal word-break">{transactionName.name}</span>
                )}
                {transactionName.tag ? (
                    <div
                        title={
                            'This transaction shows data of calls to' +
                            transactionName.name +
                            ' that were tagged with ' +
                            transactionName.tag
                        }
                        className={'label label-default tw-ml-8'}
                    >
                        {transactionName.tag}
                    </div>
                ) : null}
                {this.props.full && this.props.operation.name !== transactionIdentifier ? (
                    <div className="small text-mute">{this.props.operation.name}</div>
                ) : null}
                <TracepointIndicator operation={this.props.operation} />
            </React.Fragment>
        )
    }
}
